import EventEmitter from 'events'
import $ from 'jquery'

import FingerprintCom from './common/components/fingerprint'
import RevealPasswordCom from './common/components/password'
import IntroAnimatorCom from './common/components/animator'
import PerfectScrollbarCom from './panel/perfect-scrollbar'
import FloatingButtonsCom from './panel/floating-buttons'
import CircularChartCom from './panel/circular-chart'
import AirDatepickerCom from './panel/air-datepicker'
import TooltipCom from './common/components/tooltip'
import SwiperCom from './common/components/swiper'
import SemanticUiCom from './panel/semantic-ui'
import Subscription from './panel/subscription'
import TabsCom from './common/components/tabs'
import MembershipCom from './panel/membership'
import FormCom from './common/components/form'
import Application from './panel/application'
import TrafficGChart from './panel/traffic-g-chart'
import PlaygroundCom from './panel/playground'
import DashboardCom from './panel/dashboard'
import ClipboardCom from './panel/clipboard'
import SupportCom from './panel/support'
import OverlayCom from './panel/overlay'
import PayNowCom from './panel/pay-now'
import AddRequests from './panel/add-requests'
import UploadCom from './panel/upload'
import TableCom from './panel/table'
import ApiCom from './panel/api'

const app = { events: new EventEmitter() }

global.$ = global.jQuery = $

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach
}

const triggerChat = () => {
    const liveChatBtns = document.getElementsByClassName('live-chat')

    for (let liveChatBtn of liveChatBtns) {
        liveChatBtn.addEventListener('click', (event) => {
            if (typeof window !== 'undefined') {
                // eslint-disable-next-line no-console
                window.Beacon ? window.Beacon('open') : console.error('Chat is not available');
            }
        })
    }
}

document.addEventListener('DOMContentLoaded', function(){

    global.OverlayCom = OverlayCom(app)

    PerfectScrollbarCom(app)
    FloatingButtonsCom(app)
    RevealPasswordCom(app)
    AirDatepickerCom(app)
    CircularChartCom(app)
    IntroAnimatorCom(app)
    FingerprintCom(app)
    SemanticUiCom(app)
    MembershipCom(app)
    DashboardCom(app)
    ClipboardCom(app)
    Subscription(app)
    TrafficGChart(app)
    PlaygroundCom(app)
    Application(app)
    TooltipCom(app)
    SupportCom(app)
    SwiperCom(app)
    PayNowCom(app)
    AddRequests(app)
    UploadCom(app)
    TableCom(app)
    TabsCom(app)
    FormCom(app)
    ApiCom(app)
    triggerChat()

})
